import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { from, Observable, throwError } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { KeyService } from '../services/key.service';
import { environment } from '../../environments/environment';
// import { environment } from '../../../environments/environment';
// import { KeyService } from '../../services/key.service';


@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {

    excludedRoutes = ['/role-mappings', '/secrets', '/signer', '/keycloak', 'userinfo'];

    constructor(
    private keyService: KeyService,
    private keyclockService: KeycloakService
    ) { }

    /**
   * For encryption and decryption of data
   * @param req
   * @param next
   * @returns encrypted data
   */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return new Observable((observer) => {
            this.keyService.getClientKey().then(async () => {
                try {
                    const serverPublicKey = await this.keyService.getServerPublicKey(`${environment.fdmBaseUrl}api/crypto/jwks`);
                    let encryptedBody: any;
                    if (this.isByPass(req)) {
                        await this.keyclockService.encrypt({ publicKey: serverPublicKey }, req.body).then((encryptedData: any) => {
                            encryptedBody = encryptedData;
                        });
                    } else {
                        encryptedBody = req.body;
                    }

                    let setHeaders: any = {
                        'x-encrypted': (this.isByPass(req)) ? 'true' : 'false',
                    };
                    if (!req.url.includes('signer')) {
                        setHeaders = {
                            ...setHeaders,
                            'DPop': await this.keyclockService.dpopProof(req.url, req.method, encryptedBody?.iv || '', this.keyService.jwk.keys[0].kid),
                        };
                    }

                    const newReq = req.clone({
                        body: (this.isByPass(req)) ? { data: encryptedBody.encrypted } : req.body,
                        setHeaders: {
                            ...setHeaders
                        },
                    });

                    next.handle(newReq).pipe(
                        switchMap(async (event: HttpEvent<any>) => {
                            const isEncryptedResponse =
                event instanceof HttpResponse
                && event.headers.get('x-encrypted')?.toLowerCase() === 'true';

                            if (isEncryptedResponse) {
                                if (event.body && event.body['data']) {
                                    const decodedBody = await this.keyclockService.decrypt({ publicKey: serverPublicKey }, event.body['data'], event.headers.get('x-crypto-enabled'));
                                    observer.next(event.clone({ body: decodedBody }));
                                } else {
                                    observer.next(event.clone({ body: {} }));
                                }
                            } else {
                                observer.next(event);
                            }
                        }),
                        catchError((error) => {
                            observer.error(error);
                            return [];
                        })
                    ).subscribe({
                        complete: () => observer.complete(),
                    });
                } catch (error) {
                    observer.error(error);
                }
            });
        });
    }


    isByPass(req: HttpRequest<any>): boolean {
        const isExcludedRoute = this.excludedRoutes.some((route: string) => req.url.includes(route));
        const isReportingRequest = !!environment.reportingBaseUri && req.url.includes(environment.reportingBaseUri);

        return environment.enableEncryption && !isExcludedRoute && !isReportingRequest;
    }
}